// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__LvGAm","spinner":"Loader_spinner__GvDiX","backdrop":"Loader_backdrop__iPZUo"};